// extracted by mini-css-extract-plugin
module.exports = {"summaryItem":"booking_summaryItem_1rRA5","summaryTitle":"booking_summaryTitle_2ZCIV","summaryDes":"booking_summaryDes_3D5fX"};